import { render } from "./TournamentArenaCreatePage.vue?vue&type=template&id=790957da"
import script from "./TournamentArenaCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentArenaCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__